import Vue from 'vue'
import axios from 'axios'
import {
	Message,
	Loading
} from 'element-ui'
import {
	PDD_HEADER_PATI,
	PDD_HEADER_PAGE_CODE,
	applyPddRiskHeaders,
	waitPddRiskReady,
	isPddBootstrapUrl
} from './pddRiskHeaders'
var instance = axios.create({
	// baseURL: '/api',
	baseURL: 'https://api.zhidayd.com/',
	timeout: 50000,
	withCredentials: false,
	headers: {
		'accept': 'application/json',
		'X-Requested-With': 'XMLHttpRequest',
		// AxiosHeaders 保留首次出现的大小写；先 seed 再写入，避免变成 x-pdd-pati
		[PDD_HEADER_PATI]: undefined,
		[PDD_HEADER_PAGE_CODE]: undefined
	}
});
let loadingCount = 0;
let loadingInstance = null;

function showLoading() {
	loadingCount += 1;
	if (!loadingInstance) {
		loadingInstance = Loading.service({
			lock: true,
		});
	}
}

function hideLoading() {
	if (loadingCount <= 0) {
		return;
	}
	loadingCount -= 1;
	if (loadingCount === 0 && loadingInstance) {
		loadingInstance.close();
		loadingInstance = null;
	}
}

instance.interceptors.request.use((request) => {
	var url = request.url || ''
	var skipLoading = url.indexOf('/api/user/buyer_msg') !== -1
		|| url.indexOf('/api/user/seller_msg') !== -1
		|| url.indexOf('api/user/listing_queue_status') !== -1
		|| url.indexOf('adapipublic/config') !== -1
		|| url.indexOf('api/cloud_security/page_code') !== -1
		|| url.indexOf('utiltool/code') !== -1
		|| url.indexOf('pdd1.zhidayd.com/info') !== -1
		|| url.indexOf('/Info') !== -1
	if (!skipLoading) {
		showLoading();
	}
	if(Vue.$cookies.get('token')) {
		request.headers.Authorization = Vue.$cookies.get('token');
	}

	// page_code 本身是 bootstrap 依赖，不能等待；其它请求一律等指纹就绪后再带上头
	if (isPddBootstrapUrl(url)) {
		return request
	}

	return waitPddRiskReady().then(function(result) {
		applyPddRiskHeaders(
			request.headers,
			(result && result.pati) || (typeof window !== 'undefined' && window.pati) || '',
			(result && result.pagecode) || (typeof window !== 'undefined' && window.pagecode) || ''
		)
		return request
	})
})

instance.interceptors.response.use((response) => {
	if (response && response.data && response.data.code) {
		const status = response.data.code
		switch (status) {
			case 403:
				Vue.$cookies.remove('token');
				hideLoading();
				if (window.location.hash !== '#/login') {
					window.location.href = window.location.href.split("#")[0]+"#/login";
				}
				return Promise.reject(response);
		}
	}

	setTimeout(() => {
		hideLoading();
	}, 500);
	return response;
}, (error) => {
	hideLoading();
	return Promise.reject(error);
})
export default instance



// WEBPACK FOOTER //
// ./src/libraries/utils/axios.js